import gql from 'graphql-tag';
import { SCHEDULING_TIME_OFF_FIELDS_FRAGMENT } from './scheduling-fragments';

export const SCHEDULING_TIME_OFF_QUERY = gql`
  query ScheduleTimeOff($first: Int, $after: String, $filter: TimeOffFilter, $sort: [TimeOffSort!]) {
    timeOffs(first: $first, after: $after, filter: $filter, sort: $sort) {
      ...SchedulingTimeOffFields
      cursor
    }
  }
  ${SCHEDULING_TIME_OFF_FIELDS_FRAGMENT}
`;
